import { Injectable } from '@angular/core';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { AuthorizationApplicationEvent, IdamRegisterApplicationEvent } from '~shared/modules/application-event/models';
// prettier-ignore
import {
  ApplicationIdamRegisterEventTypeEnum
} from '~shared/modules/application-event/constants/application-idam-register-event-type.enum';
import { ApplicationAuthorizationActionType as AuthType, RegistrationTypeLabels } from '~shared/modules/application-event/constants';
import { BusinessRegistrationType, SignUpTypeEnum } from '~app/modules/authorization/constants/authorization.constant';
import { GaTrackingStringConstantEnum } from '~shared/modules/ga-tracking/constants';
import { VAT_ID_VALIDATION_GA_EVENT_LABELS } from '../constants/vat-id-check.constant';

@Injectable({
  providedIn: 'root',
})
export class IdamRegisterTrackingService {
  constructor(protected applicationEventService: ApplicationEventService) {}

  // making isPasswordless=true default so that all the 'Account Created'
  //  GA event labels will have 'Passwordless' prefix
  public idamSignUpEventTracking(isBusiness: boolean, isPasswordless = true): void {
    let label: string = isBusiness ? SignUpTypeEnum.business : SignUpTypeEnum.personal;

    if (isPasswordless) {
      label = `Passwordless - ${label}`;
    }

    this.applicationEventService.publish(
      new IdamRegisterApplicationEvent(
        ApplicationIdamRegisterEventTypeEnum.signUp,
        AuthType.AccountCreated,
        label
      ),
      true
    );
  }

  public idamSignUpErrorEventTracking(label: string): void {
    if (!label.startsWith('{') && !label.endsWith('}')) {
      label = `{ ${label} }`;
    }
    this.applicationEventService.publish(
      new IdamRegisterApplicationEvent(
        ApplicationIdamRegisterEventTypeEnum.signUpError,
        AuthType.SignupError,
        label
      ),
      true
    );
  }

  public idamSignUpEventTrackingForAlreadyExistingAccount(label) {
    this.applicationEventService.publish(
      new IdamRegisterApplicationEvent(
        ApplicationIdamRegisterEventTypeEnum.signUpError,
        AuthType.EmailAlreadyExists,
        label
      ),
      true
    );
  }

  public idamCardSignUpEventTracking(isPasswordless = true): void {
    this.applicationEventService.publish(
      new IdamRegisterApplicationEvent(
        ApplicationIdamRegisterEventTypeEnum.signUp,
        AuthType.AccountCreated,
        isPasswordless ? `Passwordless - ${RegistrationTypeLabels.Metro}` : `Passwordless - ${RegistrationTypeLabels.Metro}`
      ),
      true
    );
  }

  public idamBusinessRegistrationTypeClickEventTracking(withCard: boolean): void {
    const label = withCard ? BusinessRegistrationType.withCard : BusinessRegistrationType.newBusiness;

    this.applicationEventService.publish(
      new IdamRegisterApplicationEvent(
        ApplicationIdamRegisterEventTypeEnum.signUp,
        AuthType.BusinessRegistrationOptionClicked,
        label
      ),
      true
    );
  }

  public saveLegalAddressAsShippingAndBillingEventTracking(isSaveLegalAddressAsShippingAndBillingEnabled: boolean) {
    this.applicationEventService.publish(
      new IdamRegisterApplicationEvent(
        ApplicationIdamRegisterEventTypeEnum.signUp,
        AuthType.LegalAddressCreated,
        isSaveLegalAddressAsShippingAndBillingEnabled
          ? GaTrackingStringConstantEnum.Yes
          : GaTrackingStringConstantEnum.No,
        'Authorisation'
      ),
      true
    );
  }

  public vatIdValidationGaEventTracking(validationRemark: string): void {
    const label = VAT_ID_VALIDATION_GA_EVENT_LABELS[validationRemark.toLowerCase()];
    this.applicationEventService.publish(new AuthorizationApplicationEvent(AuthType.SignupError, label), true);
  }
}
